module.exports = __webpack_public_path__ + "img/wh.ca393cb0.svg";